// Module
var code = "<div layout=\"column\" class=\"full-height\"> <button ui-sref=\"integration.quickbooks\" permission permission-only=\"'integrations.get'\"> <img src=\"logos/quickbooks-logo.svg\"> </button> </div> ";
// Exports
export default code;